import { render, staticRenderFns } from "./pileWhiteUser.vue?vue&type=template&id=454ba288&"
import script from "./pileWhiteUser.vue?vue&type=script&lang=js&"
export * from "./pileWhiteUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports